import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import './styles/css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ViewportProvider from './containers/Viewport';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Router>
			<ViewportProvider>
				<App />
			</ViewportProvider>
		</Router>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
